export const inboxMerged = {
  inboxHeader: 'Inkorg',
  chatsHeader: 'Chattar',
  contactsHeader: 'Kontakter',
  segmentsHeader: 'Grupper',
  ordersHeader: 'Ordrar',
  exportStatus: 'Exportstatus',
  tasksExport: 'Uppgifter - Export',
  download: 'Ladda ner',
  ourAllNewOmniChannelInbox: 'Vår helt nya omnikanal-inkorg!',
  allYourMessagesContactsAndLeads: 'Alla dina meddelanden, kontakter och leads finns nu på ett ställe. Klara att sorteras och grupperas för att få ditt företag att växa!',
  close: 'Stäng',
  takeALook: 'Ta en titt',
  inProgress: 'pågår',
  appTooltip: {
    manageAllYourLeadsHere: 'Hantera alla dina leads/kontakter här',
    segmentYourUserLeads: 'Gruppera dina leads/botanvändare baserat på demografi och intressen. Dessa kommer att användas vid skapande av sändlistor.',
    manageAllBotsConversationsHere: 'Hantera alla bots konversationer här',
    manageAllYourOrdersHere: 'Hantera alla dina beställningar här',
  },
  contacts: {
    seeHowToUse: 'Se hur man använder',
    help: 'Hjälp',
    visitorName: 'Besökar Namn',
    email: 'E-post',
    phoneNumber: 'Telefonnummer',
    segment: 'Grupp',
    status: 'Status',
    tag: 'Tagg',
    action: 'Åtgärd',
    discard: 'Kasta',
    addTag: 'Lägg till Tagg',
    loadMore: 'Ladda mer',
    nA: 'NA',
    assign: 'Tilldela',
    deleteUser: 'Ta bort användare',
    areYouSureToDeleteLead: 'Är du säker på att du vill ta bort denna lead?',
    twilioIntegrationNeeded: 'Twilio Integration behövs',
    twilioIntegrationNeededDescription: 'Twilio är för närvarande inte ansluten till din inkorg. Vänligen gå vidare med integrationen för att ringa dina kunder.',
    call: 'Ring',
    twilioMakeCall: 'Twilio har integrerats framgångsrikt. Nu kan du ringa användarna.',
    makeACall: 'Ring upp',
    integrateNow: 'Integrera nu',
    subscribeUser: 'Prenumerera på användare',
    unsubscribeUser: 'Avsluta prenumerationen på användare',
    copy: 'Kopiera',
    noDataFound: {
      youDoNotHaveAnyContactsYet: 'Du har inga kontakter ännu!',
      allOfYourContactsAppearHere: 'Alla dina kontakter kommer att visas här',
    },
    placeholders: {
      searchSegmentByName: 'Sök grupp efter namn',
      searchOrAddTag: 'Sök eller lägg till en tagg',
    },
    addContacts: {
      name: 'Namn',
      email: 'E-post',
      enterAValidEmail: 'Ange en giltig e-postadress',
      phoneNumber: 'Telefonnummer',
      cancel: 'Avbryt',
      addContact: 'Lägg till Kontakt',
      placeholders: {
        enterEmailAddress: 'Ange e-postadress',
        enterUserrName: 'Ange användarnamn',
        searchCountry: 'Sök Land',
        enterPhoneNumber: 'Ange telefonnummer',
      }
    }
  },
  inboxFilter: {
    applied: 'tillämpad',
    assignTags: 'Tilldela Taggar',
    discard: 'Kasta',
    addTag: 'Lägg till Tagg',
    assignSegments: 'Tilldela Grupper',
    filterYourLeads: 'Filtrera dina leads',
    filters: 'filter',
    filter: 'filter',
    resetAllFilters: 'Återställ alla filter',
    importContacts: 'Importera Kontakter',
    beforeYouStart: 'Innan du börjar ladda upp, se till',
    point1: '1. Ladda ner exempel-excelfilen.',
    point2: '2. Börja mata in dina data från rad 2 och framåt.',
    point3: '3. I varje rad finns data för en kontakt',
    point4: '4. Se till att alla telefonnummer är unika.',
    point5: '5. Maximal filstorlek för uppladdning är 20 MB',
    selectFile: 'Välj Fil',
    clickHere: 'Klicka här',
    toDownloadSampleFile: 'för att ladda ner exempelfilen',
    modal: {
      closeLeads: 'Stäng Leads',
      areYouSureToselectAllLeads: 'Är du säker på att du vill stänga alla valda leads?',
      assignAgent: 'Tilldela Agent',
      toAssignAgentToAllLeads: 'Är du säker på att du vill tilldela en agent till alla valda leads?',
      assignTag: 'Tilldela Tagg',
      wantToReplacePreviouslyAssignedTagWithNew: 'Är du säker på att du vill ersätta tidigare tilldelade taggar med den nya valda taggen för alla valda leads?',
      deleteLeads: 'Ta bort Leads',
      wantToDeleteSelectedLeads: 'Är du säker på att du vill ta bort alla valda leads?',
      exportData: 'Exportera Data',
      exportDataBasedOn: 'Exportera data baserat på ',
      assignSegment: 'Tilldela Grupp',
      wantToAssignSegmentsToSelectedLeads: 'Är du säker på att du vill tilldela grupp till alla valda leads?',
      yesGoAhead: 'Ja, fortsätt!',
      export: 'Exportera'
    },
    appTooltip: {
      filterDataBasedOnPreferences: 'Filtrera data baserat på dina preferenser som taggar, bot, status, osv.',
      markLeadAsClosed: 'Markera användare/lead som stängd',
      assignAgentToLead: 'Tilldela agent till användare',
      assignTagToUser: 'Tilldela tagg till användare',
      exportData: 'Exportera Data',
      importContactsForWhatsappBot: 'Importera kontakter för whatsapp-bot',
      addWhatsappContact: 'Lägg till Whatsapp-kontakter',
      assignSegmentToUser: 'Tilldela grupp till användare',
      deleteUsers: 'Ta bort användare',
    },
    placeholders: {
      typeNameEmailPhoneNumberAndPressEnter: 'Skriv namn, e-post eller telefon och tryck på Enter',
      searchAgentByName: 'Sök agent efter namn',
      searchOrAddTag: 'Sök eller lägg till en tagg',
      searchSegmentByName: 'Sök grupp efter namn',
    },
    filterContainer: {
      filterOn: 'Filtrera på',
      filterBy: 'Filtrera efter',
      startFrom: 'Börja från',
      tillDate: 'Till datum',
      offlineOrOnline: 'Off-line/Online',
      liveChat: 'Livechatt',
      userInteractedWithBot: 'Användare interagerade med bot',
      discard: 'Kasta',
      applyFilter: 'Tillämpa Filter',
      bots: 'Bots',
      tags: 'Taggar',
      status: 'Status',
      assignedTo: 'Tilldelad till',
      lastMessageBy: 'Senast meddelad av',
      onlineOrOffline: 'Online/Off-line',
      userInteracted: 'Användare interagerade',
      segments: 'Grupper',
      lastSeenDate: 'Senast sedd datum',
      onboardingDate: 'Onboarding datum',
      createTags: 'Skapa Taggar',
      createTagsToSortAndManageLeads: 'Skapa taggar för att enkelt sortera och hantera dina leads',
      typeYourTagHere: 'Skriv din tagg här',
      createSegment: 'Skapa Grupp',
      manageSegmentForMarketingAutomation: 'Hantera dina grupper för marknadsautomationen',
      typeYourSegmentHere: 'Skriv din grupp här',
      unSubscribers: 'Ej prenumeranter',
      unSubscriberUsers: 'Ej prenumeranter',
      placeholders: {
        searchFilter: 'Sök filter',
        searchByBotName: 'Sök efter botnamn',
        searchOrAddTag: 'Sök eller lägg till en tagg',
        searchByAgentName: 'Sök efter agentens namn',
        searchBySegments: 'Sök efter gruppnamn',
      },
      appTooltip: {
        dateRangeYouWishToEndSelectionAt: 'Datumintervall du vill avsluta urvalet vid',
        dateRangeYouWishToStartSelectionFrom: 'Datumintervall du vill börja urvalet från',
        filterThoseThatAreOfflineOrOnline: 'Filtrera dessa användare som är offline/online',
        filterThoseThatAreCurrentlyLiveChatting: 'Filtrera dessa användare som för närvarande livechattar',
        filterThoseThatInteractedWithBot: 'Filtrera dessa användare som interagerade med boten',
        filterBySubscribers: 'Filtrera efter prenumerantstatus',
      },
      indexMergeDatePicker: {
        selectStartDate: 'Välj startdatum',
        selectEndDate: 'Välj slutdatum',
      }
    }
  },
  leads: {
    seeHowToUse: 'Se hur man använder',
    help: 'Hjälp',
    visitorName: 'Besökar Namn',
    email: 'E-post',
    phoneNumber: 'Telefonnummer',
    assignedTo: 'Tilldelad till',
    status: 'Status',
    tag: 'Tagg',
    action: 'Åtgärd',
    discard: 'Kasta',
    addTag: 'Lägg till Tagg',
    loadMore: 'Ladda mer',
    nA: 'NA',
    deleteUsers: 'Ta bort användare',
    areYouSureToDeleteLead: 'Är du säker på att du vill ta bort denna lead?',
    twilioIntegrationNeeded: 'Twilio Integration behövs',
    twilioIntegrationNeededDescription: 'För närvarande är Twilio inte ansluten till din inkorg. Vänligen gå vidare med integrationen för att ringa dina kunder.',
    call: 'Ring',
    twilioMakeCall: 'Twilio har integrerats framgångsrikt. Nu kan du ringa användarna.',
    makeACall: 'Ring upp',
    integrateNow: 'Integrera nu',
    subscribeUser: 'Prenumerera på användare',
    unsubscribeUser: 'Avsluta prenumerationen på användare',
    copy: 'Kopiera',
    noDataFound: {
      youDoNotHaveAnyChatsYet: 'Du har inte några chattar ännu',
      allOfYourChatsAppearHere: 'Alla dina chattar kommer att visas här',
    },
    placeholders: {
      searchAgentByName: 'Sök efter agentens namn',
      searchStatusByName: 'Sök status efter namn',
      searchOrAddTag: 'Sök eller lägg till en tagg',
    }
  },
  messages: {
    seeHowToUse: 'Se hur man använder',
    help: 'Hjälp',
    editChatFlow: 'Redigera Chattflöde',
    connect: 'Anslut',
    chat: {
      photo: 'Foto',
      video: 'Video',
      document: 'Dokument',
      location: 'Plats',
      assignedTo: 'Tilldelad Till',
      selectBot: 'Välj Bot',
      discard: 'Kasta',
      addTag: 'Lägg till Tagg',
      yourBrowserDoesNotSupportVideoTag: 'Din webbläsare stöder inte videoelementet.',
      userHasSharedADocument: 'Användaren har delat ett dokument.',
      clickHereToDownload: 'Klicka här för att ladda ner',
      thisStoryIsNoLongerAvailable: 'Denna historia är inte längre tillgänglig',
      yourBrowserDoesNotSupportAudioElement: 'Din webbläsare stöder inte ljudelementet.',
      thisMessageIsNoLongerAvailable: 'Detta meddelande är inte längre tillgängligt eftersom det har ångrats av avsändaren',
      userHasSharedHisLocation: 'Användaren har delat sin plats. Klicka här för att visa',
      sms: 'SMS',
      failed: 'Misslyckades',
      a: 'A',
      i: 'Jag',
      r: 'R',
      m: 'M',
      conversationsSelected: 'konversationer valda',
      nA: 'NA',
      assignTagsCloseOrBulkReply: 'Tilldela taggar, stäng eller svara på bulk till alla på en gång',
      twilioIntegrationNeeded: 'Twilio Integration behövs',
      twilioIntegrationNeededDescription: 'För närvarande är Twilio inte ansluten till din inkorg. Vänligen gå vidare med integrationen för att ringa dina kunder.',
      call: 'Ring',
      twilioMakeCall: 'Twilio har integrerats framgångsrikt. Nu kan du ringa användarna.',
      makeACall: 'Ring upp',
      integrateNow: 'Integrera nu',

      appTooltip: {
        assignAgent: 'Tilldela agent',
        selectBot: 'Välj Bot',
        callUser: 'Ring användaren',
        assignTagsToManageLeads: 'Tilldela taggar för att hantera leads och konversationer',
      },
      placeholders: {
        searchAgentByName: 'Sök agent efter namn',
        searchBotByName: 'Sök bot efter namn',
        searchOrAddTag: 'Sök eller lägg till en tagg',
        searchStatusByName: 'Sök status efter namn',
      }
    },
    profile: {
      userDetails: 'Användaruppgifter',
      orderDetails: 'Orderdetaljer',
      orderedOn: 'Beställd den',
      showMore: 'Visa mer',
      showLess: 'Visa mindre',
      subTotal: 'Delsumma',
      nA: 'NA',
      addAWhatsappNumber: 'Lägg till Whatsapp-nummer',
      addTelegramUserName: 'Lägg till Telegram-användarnamn',
      addInstagramProfileId: 'Lägg till Instagram Profil ID',
      addFacebookProfileId: 'Lägg till Facebook Profil ID',
      add: 'Lägg till',
      deviceProperties: 'Enhetsinformation',
      privateNotes: 'Privata anteckningar',
      urlsVisited: 'Besökta webbadresser',
      source: 'Källa - ',
      sourceNa: 'Källa - NA',
      medium: 'Medium - ',
      mediumNa: 'Medium - NA',
      campaign: 'Kampanj - ',
      campaignNa: 'Kampanj - NA',
      attributeKey: 'Attribut Nyckel',
      attributeName: 'Attribut Namn',
      discard: 'Kasta',
      addAttribute: 'Lägg till attribut',
      editAttribute: 'Redigera attribut',
      deleteAttribute: 'Ta bort attribut',
      headsUp: 'Hej',
      areYouSureToDeleteAttribute: 'Är du säker på att du vill ta bort detta attribut?',
      okay: 'Okej',
      dataAddedToLead: 'Attributen kopplade till dina API:er kommer inte att uppdateras. Vänligen uppdatera API:erna i enlighet med detta.',
      assignedOnly: 'Endast Tilldelade',
      allUsers: 'Alla Användare',
      save: 'Spara',
      manageCustomAttributes: 'Hantera Anpassade Attribut',
      placeholders: {
        title: 'Titel',
        egServices: 'T.ex. Tjänster',
        egRequestedServices: 'T.ex. Efterfrågade Tjänster',
        enterYourNotesHere: 'Skriv dina anteckningar här ...'
      },
      bpDropDown: {
        selectBot: 'Välj Bot',
        selectFlow: 'Välj Flöde',
        selectQuestion: 'Välj Fråga*'
      }
    },
    sendMessage: {
      send: 'Skicka',
      sendToAllChannels: 'Skicka till alla kanaler',
      email: 'E-post',
      whatsapp: 'Whatsapp',
      telegram: 'Telegram',
      facebook: 'Facebook',
      sendSms: 'Skicka SMS',
      addNew: 'Lägg till Nytt',
      addNewQuickReply: 'Lägg till Ny Snabbrespons',
      discard: 'Kasta',
      fromComputer: 'FRÅN DATORN',
      add: 'Lägg till',
      dragAndDropHereOr: 'Dra och släpp här eller',
      browseFiles: 'Bläddra bland filer',
      caption: 'Bildtext',
      templates: 'Mallar',
      addHeaderMedia: 'Lägg till sidhuvudsbild',
      selectFile: 'Välj Fil',
      previousConversationClosed: 'Föregående konversation stängd!',
      sendTemplateMessage: 'Skicka mallmeddelande för att starta konversationen igen.',
      selectTemplate: 'Välj Mall',
      conversationLocked: 'Konversation låst!',
      demoBotOnlyAllowConversations: 'Demo-boten tillåter endast konversation med det nummer du verifierade tidigare.',
      unSubscriberUser: 'Ej prenumerant',
      pleaseNoteEither: 'Observera att antingen har den här användaren avslutat prenumerationen eller vice versa. Vänligen tvinga prenumeration för att starta chatten.',
      subscribeAndStart: 'Prenumerera och starta',
      placeholders: {
        searchQuickReplyByTitle: 'Sök Snabbsvar efter titel',
        addTitle: 'Lägg till Titel',
        addYourRepliesHere: 'Lägg till dina svar här... ',
        addCaption: 'Lägg till bildtext',
        enterValueForThisVariable: 'Ange värde för denna variabel',
      },
      modal: {
        sendBulkMessages: 'Skicka Massmeddelanden',
        send: 'Skicka',
        description: 'Ditt meddelande kommer att rengöras och skickas baserat på typen av plattform som en användare tillhör.' +
          '\n - Webbplatsanvändare stöder endast textbaserade meddelanden \n - Whatsapp (icke prenumererade) kontakter kan endast ta emot mallmeddelanden'
      },
      noDataFound: {
        oops: 'Hoppsan!',
        currentlyDoesNotSupportBulkMessages: 'Vi stöder för närvarande inte massmeddelanden för whatsapp-bots. Använd sändningsfunktionen istället',
        quickReplies: 'Snabbsvar',
        noQuickRepliesAddedYet: 'Inga snabbsvar har lagts till ännu!',
      }
    },
    userList: {
      selectAll: 'Välj Alla',
      nA: 'NA',
      loadMore: 'Ladda Mer',
    }
  },
  segments: {
    seeHowToUse: 'Se hur man använder',
    help: 'Hjälp',
    manageSegment: 'Hantera Grupp',
    manageYourSegmentsForMarketingAutomation: 'Hantera dina grupper för marknadsautomationen',
    createNewSegment: 'Skapa Ny Grupp',
    segmentName: 'Gruppnamn',
    totalContacts: 'Totalt Antal Kontakter',
    action: 'Åtgärd',
    createSegmentButton: 'Skapa Grupp',
    deleteSegments: 'Ta bort Grupper',
    areYouSureToDeleteSegment: 'Är du säker på att du vill ta bort denna grupp?',
    placeholders: {
      searchHere: 'Sök här',
    },
    noDataFound: {
      youDoNotHaveAnySegmentYet: 'Du har inte skapat några grupper ännu',
      allYourSegmentsAppearHere: 'Alla dina grupper kommer att visas här'
    },
    modal: {
      exportData: 'Exportera Data',
      exportDataBasedOnAppliedFilters: 'Exportera data baserat på tillämpade filter',
      export: 'Exportera',
    },
    appTooltip: {
      deleteSegments: 'Ta bort grupper',
      editSegment: 'Redigera Grupp',
      downloadSegment: 'Ladda ner Grupp',
      deleteSegment: 'Ta bort Grupp'
    },
    createSegment: {
      createSegment: 'Skapa grupp',
      manageYourSegmentsForMarketingAutomation: 'Hantera dina grupper för marknadsautomationen',
      segmentName: 'Gruppnamn',
      segmentNameIsRequired: 'Gruppnamn krävs',
      selectContactsFilterForSegment: 'Välj kontaktfilter för Gruppen',
      filterYourContacts: 'Filtrera dina kontakter',
      removeAllFilters: 'Ta bort alla filter',
      addFilters: 'Lägg till Filter',
      discard: 'Kasta',
      filterSelected: 'Filter valda',
      placeholders: {
        enterSegmentName: 'Ange Gruppnamn',
      }
    }
  },
  orders: {
    visitorName: 'Besökar Namn',
    email: 'E-post',
    phoneNumber: 'Telefonnummer',
    status: 'Status',
    itemCount: 'Antal Artiklar',
    total: 'Totalt',
    tag: 'Tagg',
    noDataFound: {
      youDoNotHaveAnyOrdersYet: 'Du har inte några beställningar ännu',
      allOfYourOrdersAppearHere: 'Alla dina beställningar kommer att visas här'
    },
  }
};
